export default __webpack_public_path__ + "static/media/cardio.46fa3896.png";